'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import { signUp, type SignUpFetcherInput } from '@/lib/api/auth/sign-up';
import { authQueryKeys } from '@/lib/api/auth/auth-query-keys';
import type { Locale } from '@/i18n/routing';

export function useSignUp() {
  const qc = useQueryClient();
  const locale = useLocale() as Locale;
  return useMutation({
    mutationFn: (input: SignUpFetcherInput) => signUp(input, locale),
    onSuccess: (result) => {
      if (!result.requiresEmailConfirmation) {
        qc.invalidateQueries({ queryKey: authQueryKeys.all });
      }
    },
  });
}
